import { ActivateEntraUserDocument, ActivateEntraUserMutationVariables } from '@/generated/graphql';
import { useMutation } from '@vue/apollo-composable';

export function useActivateEntraUser() {
    const activateEntraUserMutation = useMutation(ActivateEntraUserDocument, {
        refetchQueries: ['GetUsersWithLoginData'],
    });

    async function activate(data: ActivateEntraUserMutationVariables) {
        const response = await activateEntraUserMutation.mutate(data);
        const result = response?.data?.activateEntraUser;
        switch (result?.__typename) {
            case 'UserWithLoginData':
                return result.id;
            case 'InvalidOid':
            case 'AlreadyLinked':
                throw new Error(`Could not activate user. ${result.message}`);
            default:
                throw new Error('Could not activate user. Unknown Error.');
        }
    }

    return {
        isActivating: activateEntraUserMutation.loading,
        activate,
    };
}
